import { Component, HostBinding, inject, input, ChangeDetectionStrategy } from "@angular/core";
import { DialogAdapter } from "common/dialog/dialog-adapter";
import { TranslateModule } from "@ngx-translate/core";
import { NgClass } from "@angular/common";
import { AutofocusDirective } from "common/autofocus/autofocus.directive";

@Component({
	selector: "stages-confirm",
	templateUrl: "./confirm.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslateModule, AutofocusDirective, NgClass],
})
export class ConfirmComponent {
	private dialog = inject(DialogAdapter);

	@HostBinding("class.confirm") customClass = true;

	readonly keys = input.required<{
		message: string;
		details?: string;
		cancel: string;
		ok: string;
		isDeleteButton: boolean;
		// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- TODO: Remove this comment and fix warnings!
		values: {};
	}>();

	cancel(): void {
		this.dialog.close("cancel");
	}

	ok(): void {
		this.dialog.close("ok");
	}
}
